<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title">Current Services</h3>
      </div>
      <div class="box-body">
        
        <div>
          <b-table :items="items" :fields="fields" class="mt-3" outlined>
            <!-- <template slot="status" slot-scope="row">
              <span class="label label-success" v-if="row.value === 'paid'">Paid</span>
              <span class="label label-warning" v-else-if="row.value === 'open'">Open</span>
            </template> -->

            <template slot="actions" slot-scope="row">
              <div class="btn-group dropup">
                <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown">
                  Actions <span class="caret"></span>
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <ul class="dropdown-menu">
                  <li><a href='#' @click="info(row.item, row.index, $event.target)">Details</a></li>
                  <li><a  @click="deleteService(row.item, row.index, $event.target)">Delete</a></li>
                </ul>
              </div>
            </template>
          </b-table>
          <div class="box-footer clearfix" style="display:contents;">
            <ul class="pagination pagination-sm no-margin pull-right" v-if="PAGINATOR.length">
                  <li v-bind:disabled="PAGE_ARROW.prev===null" @click="onPrevPagination"><a>&laquo;</a></li>
                  <li v-for="(page, index) in PAGINATOR" :key="index" :value="page.value" @click="onPagination(page.value)">
                          <a>{{ page.text }}</a>
                  </li>
                  <li  v-bind:disabled="PAGE_ARROW.next===null"  @click="onNextPagination"><a>&raquo;</a></li>
            </ul>
          </div>
        </div>
        <button type="button" class="btn btn-primary pull-left"
            @click="onOpenAssignService" >New</button>
        <button type="button" class="btn btn-success pull-right" style="margin-right: 5px;"
          @click="onClickCancel" >{{$t('common.cancel')}}</button>

      </div>
    </div>
    <!-- Modal Component -->
        <div class="modal fade" id="modal-deleteservice">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Delete Assigned Service</h4>
              </div>
              <div class="modal-body">
                {{ deleteMsg}}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary btn-green" @click="onConfirmDelete">Confirm</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
    <assign-service
      v-if="openAssignNewService"
      @assignservice-cancel="onCancelAssignService"
      @assignservice-submit="onAssignServiceSubmit"
    >
    </assign-service>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import AssignService from "./AssignService.vue"
import utils from '@/lib/utils'

export default {
  name: 'ServiceAssigned',
  data() {
    return {
      openAssignNewService: false,
      services: [{ text: 'Select One', value: null, type: null}],
      options: {
        //format: 'DD/MM/YYYY',
        format:"",
        useCurrent: false,
      },
      form: {
        dateFrom: new Date(),
        dateTo: '',
        service_name: null,
        // last_value: null,
        // current_value: null
      },
      show: true,
      fields: [
        { key: 'service_name', label: 'Service Name', sortable: true, sortDirection: 'desc' },
        { key: 'date_from', label: 'Date From', sortable: true, class: 'text-center' },
        { key: 'date_to', label: 'Date To', sortable: true, class: 'text-center' },
        // { key: 'last_value', label: 'Last Value', sortable: true, class: 'text-center' },
        // { key: 'current_value', label: 'Current Value', sortable: true, class: 'text-center' },
        // { key: 'total_fee', label: 'Total Fee', sortable: true, class: 'text-center' },
        // { key: 'status', label: 'Status', class: 'text-center' },
        // { key: 'invoice', label: 'Invoice', class: 'text-center' },
        { key: 'actions', label: 'Actions', class: 'text-center' }
      ],
      items:[],
      deleteMsg: "Are you sure you want to delete this service?",
      deleteID: null
    }
  },
  watch: {
    SERVICE_ASSIGNED_DATA: function() {
      this.items = []
      this.SERVICE_ASSIGNED_DATA.forEach(
        service_data => {
          let service_name      = service_data.service_name
          let date_from         = utils.formatSqlDate(service_data.date_from, null, "DD-MMM")
          let date_to           = utils.formatSqlDate(service_data.date_to, null, "DD-MMM", "Forever")
          let id                = service_data.id
          let data              = {
              'id': id,
              'service_name'  : service_name,
              'date_from': date_from,
              'date_to':date_to,
          };
        this.items.push(data)
            }
      );
      return this.items
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "SERVICE_ASSIGNED_DATA"
    ]),
  },
  methods: {
    info(item, index, button) {
      this.$router.push({
        name: "ServiceUserDetail",
        params: {serviceuserId: item.id}
      })
    },
    deleteService(item, index, button){
      $('#modal-deleteservice').modal('show')
      this.deleteID = item.id
    },
    onConfirmDelete: function(){
      $('#modal-deleteservice').modal('hide')
      let data = {
        id: this.deleteID
      }
      this.DELETE_ASSIGNED_SERVICE(data).then(
        function() {
          this.onReloadServiceUsage()
        }.bind(this)
      )
      .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
      );  
    },
    onAssignServiceSubmit: function(serviceuser) {
      this.ADD_ASSIGN_SERVICE(serviceuser)
        .then(
          function() {
            //this.SUCCESS_TOAST();
            this.openAssignNewService = false
            this.onReloadServiceUsage()
          }.bind(this)
        )
        .catch(
          function() {
            //this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onCancelAssignService: function() {
      this.openAssignNewService = false
    },
    fullName(value) {
      return `${value.first} ${value.last}`
    },
    onClickCancel: function(){
        this.$router.push({
        name: "CustomerAdd"
      })
    },
    onOpenAssignService: function() {
      this.openAssignNewService = true
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_SERVICE_LIST_BY_USER"
      };
      this.PAGINATION_PREV_PAGE(data)

    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_SERVICE_LIST_BY_USER"
      };
      this.PAGINATION_NEXT_PAGE(data)

    },
    onPagination: function(value) {
      if (value === 0) return false;
      const data = {
        params: {
          page: value,
        }
      };
      this.GET_SERVICE_LIST_BY_USER(data)
    },
    onReloadServiceUsage: function() {
      this.userui = this.$route.params.id;
      this.GET_SERVICE_LIST_BY_USER({userid:this.userui}).then(
        function(res) {
          let result = res.data
          result.forEach(v => {
            let data = {
              text: v.service_name,
              value: v.id,
              service: v.service
            }
            this.services.push(data)
          })
        }.bind(this)
      )
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_SERVICE_LIST_BY_USER",
      "ADD_ASSIGN_SERVICE",
      "DELETE_ASSIGNED_SERVICE"
      ]),
  },
  components: {
    'assign-service': AssignService
  },
  mounted() {
    this.onReloadServiceUsage()
  }
}

</script>

<style scoped>
.dropdown-menu {
  min-width: 80px
}
</style>


// WEBPACK FOOTER //
// src/views/Service/ServiceAssigned.vue